/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 我的报名详情
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  activityId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cms.MyApplyActivityMemberDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/cms/apply-activity-info/mine/${activityId}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
